export const SAVE = 'SAVE';
export const PRINT = 'PRINT';
export const EMAIL = 'EMAIL';
export const PREVIEW = 'PREVIEW';
export const DELETE = 'DELETE';
export const CREATE = 'CREATE';
export const APPROVE = 'APPROVE';
export const REJECT = 'REJECT';
export const CANCEL = 'CANCEL';
export const EDIT = 'EDIT';
export const INFO = 'INFO';
export const SUBMIT = 'SUBMIT';

export const createButton = (f: (e: any, cells: any) => any) => ({
	CREATE: {
		icon: 'el-icon-plus',
		onClickAction: f,
		value: CREATE,
		type: 'primary',
		isVisible: () => true,
	},
});

export const submitButton = (f: (e: any, cells: any) => any) => ({
	SUBMIT: {
		icon: 'el-icon-check',
		Tooltip: 'Submit for approval',
		onClickAction: f,
		value: SUBMIT,
		isVisible: () => true,
		Animation: true,
	},
});

export const printButton = (f: (e: any, cells: any) => any) => ({
	PRINT: {
		icon: 'el-icon-printer',
		onClickAction: f,
		value: PRINT,
		isVisible: () => true,
	},
});

export const saveButton = (f: (e: any, cells: any) => any) => ({
	SAVE: {
		icon: 'el-icon-download',
		onClickAction: f,
		value: SAVE,
		isVisible: () => true,
	},
});

export const emailButton = (f: (e: any, cells: any) => any) => ({
	EMAIL: {
		icon: 'el-icon-message',
		onClickAction: f,
		value: EMAIL,
		isVisible: () => true,
	},
});

export const previewButton = (f: (e: any, cells: any) => any) => ({
	PREVIEW: {
		icon: 'el-icon-view',
		onClickAction: f,
		value: PREVIEW,
		isVisible: () => true,
	},
});

export const deleteButton = (f: (e: any, cells: any) => any) => ({
	DELETE: {
		icon: 'el-icon-delete',
		onClickAction: f,
		value: DELETE,
		isVisible: () => true,
	},
});

export const approveButton = (f: (e: any, cells: any) => any) => ({
	APPROVE: {
		icon: 'el-icon-success',
		onClickAction: f,
		value: APPROVE,
		isVisible: () => true,
	},
});

export const rejectButton = (f: (e: any, cells: any) => any) => ({
	REJECT: {
		icon: 'el-icon-error',
		onClickAction: f,
		value: REJECT,
		isVisible: () => true,
	},
});

export const cancelButton = (f: (e: any, cells: any) => any) => ({
	CANCEL: {
		icon: 'el-icon-circle-close',
		onClickAction: f,
		value: CANCEL,
		type: 'error',
		isVisible: () => true,
	},
});
export const editButton = (f: (e: any, cells: any) => any) => ({
	CANCEL: {
		icon: 'el-icon-edit',
		onClickAction: f,
		value: EDIT,
	},
});
export const infoButton = (f: (e: any, cells: any) => any) => ({
	INFO: {
		icon: 'el-icon-info',
		onClickAction: f,
		value: INFO,
	},
});
